import React from 'react';

const ItemContext = React.createContext({});

export default ItemContext;
